import { useRef, useCallback } from "react";
import { useSocket } from "../context/SocketContext";
import useAuthStore from "../store/authStore";

const useTyping = (conversationId) => {
  const socketRef = useSocket();
  const { user } = useAuthStore();
  const typingTimeoutRef = useRef(null);
  const isTypingRef = useRef(false);

  const startTyping = useCallback(() => {
    if (!socketRef?.current || !conversationId) return;

    if (!isTypingRef.current) {
      isTypingRef.current = true;
      socketRef.current.emit("typing:start", {
        conversationId,
        userId: user._id,
        userName: user.name,
      });
    }

    clearTimeout(typingTimeoutRef.current);
    typingTimeoutRef.current = setTimeout(() => {
      isTypingRef.current = false;
      socketRef.current?.emit("typing:stop", {
        conversationId,
        userId: user._id,
      });
    }, 2000);
  }, [conversationId, user]);

  const stopTyping = useCallback(() => {
    clearTimeout(typingTimeoutRef.current);
    if (isTypingRef.current) {
      isTypingRef.current = false;
      socketRef.current?.emit("typing:stop", {
        conversationId,
        userId: user._id,
      });
    }
  }, [conversationId, user]);

  return { startTyping, stopTyping };
};

export default useTyping;
